import { Table } from '@statsbomb/kitbag-components';
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const getTranslationString = (intl) => ({
  alignmentStatus: intl.formatMessage({
    defaultMessage: 'Alignment Status',
    id: '3a2f2',
  }),
  lastUpdatedBy: intl.formatMessage({
    defaultMessage: 'Last Updated By',
    id: '7ce1b',
  }),
});

export function AlignmentStatusTable({ lastUpdatedBy, alignmentStatus }) {
  const intl = useIntl();

  return (
    <Table>
      <Table.Head>
        <Table.HeaderCell colSpan={2}>
          {getTranslationString(intl).alignmentStatus}
        </Table.HeaderCell>
      </Table.Head>
      <Table.Body>
        <Table.Row>
          <Table.DataCell $textAlign="left">
            {getTranslationString(intl).lastUpdatedBy}
          </Table.DataCell>
          <Table.DataCell $textAlign="left">
            {lastUpdatedBy || '-'}
          </Table.DataCell>
        </Table.Row>
        <Table.Row>
          <Table.DataCell $textAlign="left">
            {getTranslationString(intl).alignmentStatus}
          </Table.DataCell>
          <Table.DataCell $textAlign="left">{alignmentStatus}</Table.DataCell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}

AlignmentStatusTable.propTypes = {
  alignmentStatus: PropTypes.string.isRequired,
  lastUpdatedBy: PropTypes.string.isRequired,
};

export default { AlignmentStatusTable };
